<template>
    <div class="loading-overlay auth-loading-overlay" :class="{ hidden: !display }">
        <div class="loading-overlay-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineOptions({ name: "AuthLoadingOverlay" });

defineProps<{
    display?: boolean;
}>();
</script>

<style></style>
